import React from 'react';
import { TextField, Grid } from '@mui/material';
import { withStyles, makeStyles } from 'tss-react/mui';
import PropTypes from 'prop-types';
import _ from 'lodash';
import AxlAutocomplete from './AxlAutocomplete';
import AxlSelect from './AxlSelect';

const StyledTextField = withStyles(TextField, (theme) => ({
  root: {
    marginTop: theme.spacing(1),
    '& input': {
      paddingTop: '10px',
      paddingBottom: '10px',
    },
  },
}));

const useStyles = makeStyles()((theme) => ({
  root: {
    '& .Mui-error': {
      marginLeft: 0,
    },
  },
  subLabel: {
    color: '#4a90e2',
    fontSize: 14,
  },
}));

FormAdd2.propTypes = {
  datas: PropTypes.object,
};

function FormAdd2(props) {
  const { classes } = useStyles();

  const { handleChange, error, list, datas = {} } = props;
  return (
    <form onChange={handleChange} className={classes.root}>
      <Grid container spacing={3}>
        {list?.filter(Boolean)?.map((item) => {
          const type = item.type ? item.type : ['password', 'email'].includes(item.id) ? item.id : 'text';
          if (type === 'autocomplete') {
            return (
              <Grid key={item.id} size={item.column ? item.column : 12}>
                <span>
                  {item.label}
                  <i className={classes.subLabel}> {item.subLabel}</i>
                </span>
                <AxlAutocomplete
                  style={item.style}
                  isMultiple={true}
                  isFreeSolo={true}
                  options={item.options}
                  error={!!error[item.id]}
                  helperText={error[item.id]}
                  handleChange={item.handleChange}
                  value={item.id in datas ? item.options.filter((option) => datas[item.id].includes(option.value)) : []}
                  isOptionEqualToValue={(option, value) => option.value === value.value}
                  placeholder={item.placeholder}
                />
              </Grid>
            );
          }
          if (type === 'autoselect') {
            return (
              <Grid key={item.id} size={item.column ? item.column : 12}>
                <span>
                  {item.label}
                  <i className={classes.subLabel}> {item.subLabel}</i>
                </span>
                <AxlSelect
                  value={item.id in datas ? datas[item.id] : ''}
                  options={item.options}
                  onChange={item.handleChange}
                  placeholder={item.placeholder}
                  error={!!error[item.id]}
                  helperText={error[item.id]}
                  style={item.style}
                />
              </Grid>
            );
          }
          return (
            <Grid key={item.id} size={item.column ? item.column : 12}>
              <span>
                {item.label}
                <i className={classes.subLabel}> {item.subLabel}</i>
              </span>
              <StyledTextField
                type={type}
                value={item.id in datas ? datas[item.id] : ''}
                autoFocus={item.id === 'username'}
                id={item.id}
                name={item.id}
                disabled={'disabled' in item ? item.disabled : false}
                required
                fullWidth
                error={!!error[item.id]}
                helperText={error[item.id]}
                variant="outlined"
                inputProps={{
                  maxLength: item.maxLength,
                }}
              />
            </Grid>
          );
        })}
      </Grid>
    </form>
  );
}
export default React.memo(FormAdd2);
